module.exports = __webpack_public_path__ + "img/About_pic1.4d2942bd.png";